/** API route map: URLS.Controller.PayrollHistory */
export const PayrollHistory = {
      Name: 'PayrollHistory/',
      GetAll: 'get-all',
      ReviewSummary: 'review-summary',
      CompanyReview: 'company-review',
      TaxReview: 'tax-review/',
      EmployeeReview: 'employee-review',
      BilledReview: 'billed-review',
      ReversePayroll: 'reverse/',
      HistoryDetails: 'get-detials/',
      PaidInvice: 'paid-invoice-payroll/',
};
